import logoPicture from "images/le-club/history/logo.webp";
import Polaroid1 from "images/le-club/history/polaroid-1.webp";
import Polaroid2 from "images/le-club/history/polaroid-2.webp";
import Polaroid3 from "images/le-club/history/polaroid-3.webp";
import polaroidGroupPicture from "images/le-club/history/polaroid-group.webp";
import MobileClubLogoPicture from "images/shared/mobile-club.webp";
import dynamic from "next/dynamic";

import { CheckeredContainer } from "ui/CheckeredContainer";
import { StaticImage } from "ui/StaticImage";
import { useGetLottieScrollPosition } from "utils/useGetLottieScrollPosition";
import { useI18n } from "utils/with-i18n.utils";

import circleAnimation from "./circle.json";
import CurvedArrowSVG from "./curved-arrow.svg";
import GroupVectorSVG from "./group-vector.svg";

const Lottie = dynamic(() => import("react-lottie-player"));

export const History = () => {
  const i18n = useI18n();
  const { animationContainerRef, animationStartFrame } =
    useGetLottieScrollPosition<HTMLParagraphElement>();

  return (
    <CheckeredContainer className="flex flex-col items-center pb-16 lg:pb-24">
      <div className="relative mx-20 mt-12">
        <StaticImage
          src={logoPicture}
          priority
          alt="Club page logo"
          placeholder="blur"
          width={512}
          height={398}
        />
      </div>
      <div className="flex gap-x-8 px-14 w-full max-w-lg lg:mt-4 lg:max-w-7xl">
        <div className="hidden relative basis-1/2 lg:block">
          <StaticImage
            src={polaroidGroupPicture}
            priority
            alt="Polaroid group image"
            placeholder="blur"
            width={1174}
            height={1320}
          />
          <div className="absolute -top-5 left-32">
            <GroupVectorSVG />
          </div>
          <div className="absolute left-52 -mt-4">
            <CurvedArrowSVG />
          </div>
        </div>
        <article className="flex flex-col items-center text-center lg:basis-1/2 lg:items-start lg:mt-10 lg:text-left">
          <div className="px-12 mt-12 mb-6 lg:hidden">
            <StaticImage
              alt="polaroid image 1"
              src={Polaroid1}
              priority
              placeholder="blur"
              width={391}
              height={450}
            />
          </div>
          <h2 className="my-2 text-2xl font-medium lg:my-0 lg:mb-2 lg:text-3xl lg:font-bold">
            {i18n.t("club.history.story.heading")}
          </h2>

          <p className="lg:text-lg">
            {i18n.t("club.history.story.description")}
          </p>
          <div className="px-12 mt-16 mb-6 lg:hidden">
            <StaticImage
              alt="polaroid image 2"
              src={Polaroid2}
              placeholder="blur"
              width={391}
              height={450}
            />
          </div>
          <h2 className="my-2 text-2xl font-medium lg:my-0 lg:mt-12 lg:mb-2 lg:text-3xl lg:font-bold">
            {i18n.t("club.history.pay.heading")}
          </h2>
          <p className="lg:text-lg">
            {i18n.t("club.history.pay.description1")}
            <br className="lg:hidden" />
            {i18n.t("club.history.pay.description2")}
            <br />
            {i18n.t("club.history.pay.description3")}
          </p>
          <div className="px-12 mt-16 mb-6 lg:hidden">
            <StaticImage
              alt="polaroid image 3"
              src={Polaroid3}
              placeholder="blur"
              width={391}
              height={450}
            />
          </div>
          <h2 className="my-2 text-2xl font-medium lg:my-0 lg:mt-12 lg:mb-2 lg:text-3xl lg:font-bold">
            {i18n.t("club.history.phone.heading")}
          </h2>

          <p className="lg:text-lg">
            {i18n.t("club.history.phone.description1")}{" "}
            <br className="hidden lg:block" />
            {i18n.t("club.history.phone.description2")}
            <br />
            {i18n.t("club.history.phone.description3")}
          </p>
        </article>
      </div>
      <div
        className="flex relative flex-col mt-14 text-2xl lg:flex-row lg:text-4xl"
        ref={animationContainerRef}
      >
        <Lottie
          goTo={animationStartFrame}
          animationData={circleAnimation}
          className="absolute -top-12 -right-12 w-64 lg:hidden"
        />
        {i18n.t("club.history.born")} <br className="lg:hidden" />
        <div className="relative h-5 lg:mt-1 lg:ml-4 lg:w-64 lg:h-7">
          <StaticImage
            src={MobileClubLogoPicture}
            alt="Mobile club logo"
            placeholder="blur"
            sizes="(max-width: 1024px) 50vw, 33vw"
            layout="fill"
            objectFit="contain"
          />
        </div>
      </div>
    </CheckeredContainer>
  );
};
